// apps-kb-state.js - Keyboard navigation state

export const keyboardState = {
    virtualCursor: {
        active: false,
        rank: 0,
        file: 0,
        isInModalZone: false,
        modalZonePosition: null,
        isInInsertZone: false,
        insertZoneType: null,
        isOnDeleteButton: false
    },
    moveMode: {
        active: false,
        draggedIcon: null,
        originalRegion: null,
        originalPosition: null,
        originalFolder: null,
        currentInsertRegion: null,
        currentInsertPosition: null,
        insertBefore: null
    },
    contextMenu: {
        active: false,
        selectedIndex: 0,
        options: [
            { label: 'Open', key: 'Return', action: 'open' },
            { label: 'Edit...', key: 'E', action: 'edit' },
            { label: 'Move', key: 'M', action: 'move' }
        ]
    },
    lastFocusableElement: null,
    scrollZoneHover: null
};

export function resetCursorState() {
    keyboardState.virtualCursor.active = false;
    keyboardState.virtualCursor.isInModalZone = false;
    keyboardState.virtualCursor.modalZonePosition = null;
    keyboardState.virtualCursor.isInInsertZone = false;
    keyboardState.virtualCursor.insertZoneType = null;
}

export function resetMoveMode() {
    keyboardState.moveMode.active = false;
    keyboardState.moveMode.draggedIcon = null;
    keyboardState.moveMode.originalRegion = null;
    keyboardState.moveMode.originalPosition = null;
    keyboardState.moveMode.originalFolder = null;
    keyboardState.moveMode.currentInsertRegion = null;
    keyboardState.moveMode.currentInsertPosition = null;
    keyboardState.moveMode.insertBefore = null;
}

export function resetContextMenu() {
    keyboardState.contextMenu.active = false;
    keyboardState.contextMenu.selectedIndex = 0;
}

export function getKeyboardState() {
    return keyboardState;
}
